'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _navContent = require('./nav-content');

var _footerContent = require('./footer-content');

var _service = require('./service');

var _service2 = _interopRequireDefault(_service);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('webPublicClient.app.shared.constants', []).constant('NAV_CONTENT', _navContent.NAV_CONTENT).constant('FOOTER_CONTENT', _footerContent.FOOTER_CONTENT).constant('SERVICE', new _service2.default('/dsw/webPublicClient/secure/jas'));


// WEBPACK FOOTER //
// ./src/app/shared/constants/index.js